export interface ContentItem {
  id: string;
  title: string;
  category: 'jdrama' | 'kdrama' | 'movie' | 'variety';
  categoryLabel: string;
  image: string;
  rating: number;
  year: number;
  country: string;
  description: string;
  longDescription: string;
  subtitleStatus: string;
  updateSpeed: string;
  episodeCount: string;
  genre: string[];
  cast: string[];
  platforms: { name: string; url: string; hasSubtitle: boolean; speed: string }[];
  tags: string[];
  featured: boolean;
  trending: boolean;
  updateDate: string;
  faq: { question: string; answer: string }[];
}

export interface CategoryInfo {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: CategoryInfo[] = [
  {
    slug: 'jdrama',
    name: '日剧',
    description: '最新最全日剧中文字幕资源，涵盖爱情、悬疑、职场、校园等全类型',
    icon: 'ri-earth-line',
    count: 48,
  },
  {
    slug: 'kdrama',
    name: '韩剧',
    description: '热门韩剧中文字幕追剧指南，浪漫爱情、悬疑犯罪、奇幻穿越一网打尽',
    icon: 'ri-global-line',
    count: 56,
  },
  {
    slug: 'movie',
    name: '日韩电影',
    description: '日韩电影中文字幕大全，院线大片、经典佳作、独立电影应有尽有',
    icon: 'ri-film-line',
    count: 72,
  },
  {
    slug: 'variety',
    name: '日韩综艺',
    description: '热门日韩综艺中文字幕，搞笑、美食、旅行、真人秀全品类覆盖',
    icon: 'ri-tv-2-line',
    count: 35,
  },
];

export const contentList: ContentItem[] = [
  {
    id: 'jdrama-1',
    title: 'silent',
    category: 'jdrama',
    categoryLabel: '日剧',
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20Japanese%20drama%20poster%20featuring%20a%20young%20couple%20in%20winter%20snow%20scene%2C%20soft%20warm%20lighting%2C%20emotional%20atmosphere%2C%20minimalist%20design%20with%20Japanese%20text%20style%2C%20cinematic%20photography%2C%20gentle%20color%20palette%20of%20cream%20and%20soft%20beige%2C%20clean%20composition&width=800&height=1100&seq=jdrama-silent-01&orientation=portrait',
    rating: 9.2,
    year: 2022,
    country: '日本',
    description: '川口春奈与目黑莲主演的催泪纯爱日剧，讲述因疾病失去听力的少年与初恋女孩重逢的故事。',
    longDescription: '<p>《silent》是2022年富士电视台推出的秋季日剧，由川口春奈主演，目黑莲（Snow Man）共演。故事讲述高中时期相恋的青羽紬和佐仓想，因想患上"年轻发病型两侧性感音听力障碍"而突然从紬面前消失。八年后，两人在东京重逢，但想已经完全失去听力，两人的世界被一道无声的墙隔开。这部剧以细腻的笔触描绘了无声世界中的爱与痛，被誉为近年最催泪的纯爱日剧。</p><p>本剧播出后在日本引发巨大反响，收视率节节攀升，社交媒体讨论度极高。目黑蓮凭借此剧获得第31届桥田赏新人赏，其细腻的手语表演更是获得聋哑人士社群的高度认可。</p><p>中文字幕由各大字幕组精心制作，翻译质量极高，特别对手语部分的翻译处理尤为用心，帮助中文观众完整理解剧情的情感层次。</p>',
    subtitleStatus: '中文字幕已完结',
    updateSpeed: '播出后24小时内出字幕',
    episodeCount: '全11集',
    genre: ['爱情', '剧情', '催泪'],
    cast: ['川口春奈', '目黑莲', '铃鹿央士', '樱田日和'],
    platforms: [
      { name: 'Netflix', url: '#', hasSubtitle: true, speed: '同步更新' },
      { name: 'KKTV', url: '#', hasSubtitle: true, speed: '播出后6小时' },
      { name: 'friDay影音', url: '#', hasSubtitle: true, speed: '播出后12小时' },
    ],
    tags: ['催泪神作', '手语恋爱', '日剧必看', '川口春奈', '目黑莲'],
    featured: true,
    trending: true,
    updateDate: '2023-01-15',
    faq: [
      { question: '《silent》在哪个平台可以看？', answer: '《silent》可在Netflix、KKTV、friDay影音等平台观看，均提供中文字幕。播出后最快6小时内即可看到中文字幕版本。' },
      { question: '《silent》一共多少集？', answer: '《silent》全剧共11集，目前已全部完结，可以一口气追完。' },
    ],
  },
  {
    id: 'jdrama-2',
    title: '重启人生',
    category: 'jdrama',
    categoryLabel: '日剧',
    image: 'https://readdy.ai/api/search-image?query=A%20quirky%20Japanese%20drama%20poster%20featuring%20four%20women%20friends%20in%20casual%20everyday%20setting%2C%20playful%20and%20warm%20atmosphere%2C%20pastel%20color%20palette%2C%20Japanese%20slice%20of%20life%20aesthetic%2C%20clean%20minimalist%20design%2C%20soft%20natural%20lighting&width=800&height=1100&seq=jdrama-brushup-02&orientation=portrait',
    rating: 9.4,
    year: 2023,
    country: '日本',
    description: '安藤樱主演的奇幻喜剧日剧，讲述普通女性意外死亡后不断重生、积累阴德试图投胎为人的奇妙故事。',
    longDescription: '<p>《重启人生》（ブラッシュアップライフ）是2023年日本电视台推出的奇幻喜剧，由笨蛋节奏编剧，安藤樱主演。故事讲述33岁的近藤麻美意外死亡后来到"死后投胎服务台"，被告知下辈子将投胎为危地马拉的大食蚁兽。为了投胎为人，麻美选择重新活一次，不断积累阴德。然而即使重来，她依然只是一个普通的公务员，过着平凡但有趣的人生。</p><p>本剧凭借精妙的剧本、安藤樱精湛的演技以及对"平凡人生"的深刻洞察，成为2023年口碑最高的日剧之一。豆瓣评分高达9.4分，被誉为"年度最佳日剧"。</p>',
    subtitleStatus: '中文字幕已完结',
    updateSpeed: '播出后24小时内出字幕',
    episodeCount: '全10集',
    genre: ['奇幻', '喜剧', '剧情'],
    cast: ['安藤樱', '夏帆', '木南晴夏', '松坂桃李'],
    platforms: [
      { name: 'Netflix', url: '#', hasSubtitle: true, speed: '全集上线' },
      { name: 'KKTV', url: '#', hasSubtitle: true, speed: '播出后12小时' },
    ],
    tags: ['口碑神作', '奇幻喜剧', '安藤樱', '笨蛋节奏'],
    featured: true,
    trending: true,
    updateDate: '2023-04-05',
    faq: [
      { question: '《重启人生》为什么评分这么高？', answer: '《重启人生》以独特的轮回设定和细腻的日常描写打动了无数观众。编剧笨蛋节奏的剧本巧妙而温暖，安藤樱的表演丝丝入扣，让人在欢笑中思考人生的意义。' },
    ],
  },
  {
    id: 'jdrama-3',
    title: 'VIVANT',
    category: 'jdrama',
    categoryLabel: '日剧',
    image: 'https://readdy.ai/api/search-image?query=A%20thrilling%20Japanese%20drama%20poster%20featuring%20a%20man%20in%20desert%20landscape%2C%20epic%20cinematic%20scale%2C%20dramatic%20lighting%2C%20mystery%20and%20suspense%20atmosphere%2C%20warm%20desert%20tones%2C%20international%20spy%20thriller%20aesthetic&width=800&height=1100&seq=jdrama-vivant-03&orientation=portrait',
    rating: 8.9,
    year: 2023,
    country: '日本',
    description: '堺雅人主演的超大规模国际谍战剧，在蒙古沙漠实地取景，剧情反转不断，制作规模创日剧纪录。',
    longDescription: '<p>《VIVANT》是TBS电视台2023年夏季日剧，由堺雅人主演，阿部宽、役所广司、二阶堂富美、松坂桃李等豪华阵容共演。故事讲述丸菱商事的职员乃木忧助在蒙古出差时卷入一起国际恐怖主义事件，从而揭开了一个关乎日本国家安全的巨大阴谋。</p><p>本剧制作成本高达每集1亿日元，远赴蒙古实地取景拍摄，是日剧史上规模最大的制作之一。剧本由《半泽直树》编剧福泽克雄操刀，剧情反转不断，每一集都有颠覆性的展开。</p>',
    subtitleStatus: '中文字幕已完结',
    updateSpeed: '播出后24小时内出字幕',
    episodeCount: '全10集',
    genre: ['谍战', '悬疑', '剧情'],
    cast: ['堺雅人', '阿部宽', '役所广司', '二阶堂富美', '松坂桃李'],
    platforms: [
      { name: 'Netflix', url: '#', hasSubtitle: true, speed: '全集上线' },
      { name: 'KKTV', url: '#', hasSubtitle: true, speed: '播出后12小时' },
      { name: 'Hami Video', url: '#', hasSubtitle: true, speed: '播出后12小时' },
    ],
    tags: ['谍战巨制', '豪华卡司', '蒙古取景', '堺雅人'],
    featured: true,
    trending: false,
    updateDate: '2023-09-20',
    faq: [],
  },
  {
    id: 'kdrama-1',
    title: '黑暗荣耀',
    category: 'kdrama',
    categoryLabel: '韩剧',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20Korean%20drama%20poster%20with%20a%20woman%20in%20elegant%20black%20outfit%2C%20revenge%20theme%2C%20dramatic%20lighting%20with%20shadows%2C%20cold%20and%20intense%20atmosphere%2C%20Korean%20cinematic%20style%2C%20minimalist%20composition%20with%20strong%20contrast&width=800&height=1100&seq=kdrama-glory-01&orientation=portrait',
    rating: 9.3,
    year: 2023,
    country: '韩国',
    description: '宋慧乔主演的复仇题材韩剧，讲述遭受校园暴力后精心策划复仇计划的女主角的故事，Netflix全球热播。',
    longDescription: '<p>《黑暗荣耀》（더 글로리）是Netflix原创韩剧，由金银淑编剧，宋慧乔、李到晛主演。故事讲述文东恩在高中时期遭受残酷的校园暴力后退学，她花了近20年时间精心策划了一场完美的复仇。她成为了施暴者女儿的小学班主任，一步步接近并摧毁那些曾经伤害过她的人。</p><p>本剧分为两部分播出，Part 1和Part 2均在Netflix全球排行榜上名列前茅，引发了全球性的追剧热潮。宋慧乔凭借此剧展现了前所未有的暗黑演技，获得了观众和评论界的一致好评。</p>',
    subtitleStatus: '中文字幕已完结',
    updateSpeed: 'Netflix同步上线中文字幕',
    episodeCount: '全16集（共2季）',
    genre: ['复仇', '剧情', '悬疑'],
    cast: ['宋慧乔', '李到晛', '林智妍', '朴成勋'],
    platforms: [
      { name: 'Netflix', url: '#', hasSubtitle: true, speed: '同步上线' },
    ],
    tags: ['Netflix原创', '复仇爽剧', '宋慧乔', '校园暴力'],
    featured: true,
    trending: true,
    updateDate: '2023-03-10',
    faq: [
      { question: '《黑暗荣耀》有第二季吗？', answer: '有的！《黑暗荣耀》分为Part 1（第1-8集）和Part 2（第9-16集），已于2023年3月全部上线，16集完整完结。' },
      { question: '《黑暗荣耀》适合什么人看？', answer: '如果你喜欢复仇爽剧、精致叙事和高水准演技，这部剧绝对不会让你失望。注意剧中包含校园暴力等沉重主题。' },
    ],
  },
  {
    id: 'kdrama-2',
    title: '泪之女王',
    category: 'kdrama',
    categoryLabel: '韩剧',
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20drama%20poster%20featuring%20a%20couple%20in%20luxurious%20setting%2C%20elegant%20fashion%2C%20emotional%20tearful%20expression%2C%20warm%20golden%20lighting%2C%20Korean%20melodrama%20aesthetic%2C%20soft%20romantic%20atmosphere%2C%20high-end%20visual%20style&width=800&height=1100&seq=kdrama-queen-02&orientation=portrait',
    rating: 8.8,
    year: 2024,
    country: '韩国',
    description: '金秀贤与金智媛主演的豪门爱情剧，讲述财阀三代女王与农村出身丈夫之间啼笑皆非的婚姻危机故事。',
    longDescription: '<p>《泪之女王》（눈물의 여왕）是tvN 2024年推出的周末连续剧，由金秀贤和金智媛主演，编剧朴智恩（《来自星星的你》、《爱的迫降》）执笔。故事讲述Queens集团财阀三代洪海仁（金智媛 饰）与农村出身的丈夫白贤宇（金秀贤 饰）结婚三年后遭遇婚姻危机，两人在危机中重新发现彼此的爱情故事。</p><p>本剧一经播出便创下tvN历代最高收视率，金秀贤和金智媛的化学反引发全网热议，被誉为"2024年最甜的韩剧"。剧中金智媛饰演的女王人设霸气又可爱，金秀贤的哭戏更是被称为"教科书级别"。</p>',
    subtitleStatus: '中文字幕连载中',
    updateSpeed: '播出后6小时内出字幕',
    episodeCount: '全16集（已完结）',
    genre: ['爱情', '喜剧', '剧情'],
    cast: ['金秀贤', '金智媛', '朴成勋', '郭东延'],
    platforms: [
      { name: 'Netflix', url: '#', hasSubtitle: true, speed: '同步上线' },
      { name: 'TVING', url: '#', hasSubtitle: true, speed: '同步上线' },
    ],
    tags: ['浪漫喜剧', '豪门爱情', '金秀贤', '金智媛', '收视冠军'],
    featured: false,
    trending: true,
    updateDate: '2024-05-01',
    faq: [],
  },
  {
    id: 'kdrama-3',
    title: '背着善宰跑',
    category: 'kdrama',
    categoryLabel: '韩剧',
    image: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20Korean%20drama%20poster%20with%20a%20young%20couple%20running%20in%20school%20uniform%2C%20youthful%20and%20nostalgic%20atmosphere%2C%20warm%20sunlight%2C%20Korean%20youth%20romance%20aesthetic%2C%20soft%20pastel%20colors%2C%20high%20school%20background&width=800&height=1100&seq=kdrama-lovely-03&orientation=portrait',
    rating: 9.0,
    year: 2024,
    country: '韩国',
    description: '边佑锡与金惠允主演的穿越时空爱情剧，讲述女主穿越回过去拯救偶像男神的故事，甜到爆表。',
    longDescription: '<p>《背着善宰跑》（선재 업고 튀어）是tvN 2024年月火剧，改编自同名网络小说，由边佑锡和金惠允主演。故事讲述因意外事故而半身不遂的林率（金惠允 饰），在绝望中获得了一个神奇手表，可以穿越回到过去。她穿越回高中时期，决定改变命运，拯救当时还是练习生的偶像柳善宰（边佑锡 饰）。</p><p>本剧凭借清新治愈的画风、演员们的出色表现和甜蜜的恋爱线，成为2024年上半年口碑最好的韩剧之一。边佑锡和金惠允的CP感极强，被称为"今年最甜的CP"。</p>',
    subtitleStatus: '中文字幕已完结',
    updateSpeed: '播出后8小时内出字幕',
    episodeCount: '全16集',
    genre: ['爱情', '奇幻', '青春'],
    cast: ['边佑锡', '金惠允', '宋建熙', '李承协'],
    platforms: [
      { name: 'Viki', url: '#', hasSubtitle: true, speed: '播出后8小时' },
      { name: 'friDay影音', url: '#', hasSubtitle: true, speed: '播出后12小时' },
    ],
    tags: ['穿越爱情', '青春校园', '边佑锡', '金惠允', '治愈'],
    featured: false,
    trending: true,
    updateDate: '2024-06-20',
    faq: [],
  },
  {
    id: 'movie-1',
    title: '铃芽之旅',
    category: 'movie',
    categoryLabel: '日韩电影',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20anime%20movie%20poster%20featuring%20a%20young%20girl%20standing%20in%20front%20of%20a%20mysterious%20door%20in%20water%2C%20fantastical%20atmosphere%2C%20Makoto%20Shinkai%20style%20vibrant%20blue%20sky%2C%20dreamy%20cloud%20scenery%2C%20warm%20golden%20light&width=800&height=1100&seq=movie-suzume-01&orientation=portrait',
    rating: 8.7,
    year: 2023,
    country: '日本',
    description: '新海诚导演的动画电影，讲述少女铃芽与"闭门师"草太一起关闭灾难之门、拯救日本的奇幻冒险故事。',
    longDescription: '<p>《铃芽之旅》（すずめの戸締まり）是新海诚导演的第八部动画长片，被誉为"灾难三部曲"的收官之作（前两部分别为《你的名字。》和《天气之子》）。故事讲述17岁少女岩户铃芽在九州乡间遇到了一名寻找"门"的神秘青年宗像草太，随后意外打开了一扇"往门"，卷入了关闭各地废墟中"往门"、阻止灾害发生的冒险。</p><p>本片在日本票房突破147亿日元，全球票房超3亿美元，在中国大陆也取得了超过8亿人民币的票房成绩。中文字幕版由专业团队精心制作，字幕质量极高。</p>',
    subtitleStatus: '中文字幕已上线',
    updateSpeed: '蓝光发售后24小时内出字幕',
    episodeCount: '片长121分钟',
    genre: ['动画', '奇幻', '冒险'],
    cast: ['原菜乃华', '松村北斗', '深津绘里'],
    platforms: [
      { name: 'Netflix', url: '#', hasSubtitle: true, speed: '已上线' },
      { name: 'Amazon Prime', url: '#', hasSubtitle: true, speed: '已上线' },
      { name: 'Crunchyroll', url: '#', hasSubtitle: true, speed: '已上线' },
    ],
    tags: ['新海诚', '动画电影', '治愈系', '视觉盛宴'],
    featured: true,
    trending: false,
    updateDate: '2023-11-20',
    faq: [
      { question: '《铃芽之旅》和新海诚之前的作品有关系吗？', answer: '没有直接关系。《铃芽之旅》是"灾难三部曲"的第三部，讲述了一个全新的独立故事，没有看前两部也可以完全理解剧情。' },
    ],
  },
  {
    id: 'movie-2',
    title: '破墓',
    category: 'movie',
    categoryLabel: '日韩电影',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20Korean%20occult%20horror%20movie%20poster%20featuring%20traditional%20Korean%20shaman%20ritual%20scene%2C%20mysterious%20and%20eerie%20atmosphere%2C%20dark%20forest%20background%2C%20traditional%20Korean%20elements%2C%20cinematic%20horror%20aesthetic%2C%20deep%20earthy%20tones&width=800&height=1100&seq=movie-exhuma-02&orientation=portrait',
    rating: 8.5,
    year: 2024,
    country: '韩国',
    description: '崔岷植、金高银主演的韩国超自然恐怖片，讲述风水师、巫师和入殓师迁葬过程中遭遇的诡异事件。',
    longDescription: '<p>《破墓》（파묘）是2024年韩国超自然悬疑恐怖电影，由张在现导演，崔岷植、金高银、柳海真、李到晛主演。故事讲述一个富裕家庭遭遇一连串超自然事件后，请来风水师（崔岷植 饰）、巫师（金高银 饰）和入殓师（柳海真 饰）组成的团队迁葬祖坟，却意外释放了一个被封印的邪恶存在。</p><p>本片在韩国上映后打破多项票房纪录，观影人次突破1000万。影片融合了韩国传统巫俗文化和风水学，既有恐怖元素又有深刻的社会隐喻。中文字幕翻译精准到位，特别对韩国传统文化术语的翻译尤为出色。</p>',
    subtitleStatus: '中文字幕已上线',
    updateSpeed: '蓝光发售后24小时内出字幕',
    episodeCount: '片长134分钟',
    genre: ['恐怖', '悬疑', '超自然'],
    cast: ['崔岷植', '金高银', '柳海真', '李到晛'],
    platforms: [
      { name: 'Amazon Prime', url: '#', hasSubtitle: true, speed: '已上线' },
    ],
    tags: ['票房冠军', '韩国恐怖片', '崔岷植', '金高银', '超自然'],
    featured: false,
    trending: true,
    updateDate: '2024-06-15',
    faq: [],
  },
  {
    id: 'variety-1',
    title: '新西游记',
    category: 'variety',
    categoryLabel: '日韩综艺',
    image: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20variety%20show%20poster%20featuring%20a%20group%20of%20comedians%20in%20colorful%20traditional%20costumes%2C%20playful%20and%20energetic%20atmosphere%2C%20bright%20vibrant%20colors%2C%20travel%20theme%2C%20Korean%20entertainment%20style%2C%20festive%20mood&width=800&height=1100&seq=variety-journey-01&orientation=portrait',
    rating: 9.6,
    year: 2023,
    country: '韩国',
    description: '罗英锡PD打造的国民级旅行综艺，姜虎东、李秀根等人化身西游记角色环游世界，笑点密集。',
    longDescription: '<p>《新西游记》（신서유기）是tvN推出的旅行综艺节目，由韩国金牌PD罗英锡打造。节目设定成员们分别扮演《西游记》中的角色（姜虎东-猪八戒、李寿根-孙悟空、殷志源-沙悟净等），前往世界各地完成各种搞笑任务和游戏挑战。</p><p>该系列自2015年开播以来已推出多季，每一季都获得极高收视率和口碑。最新一季保持了9.6分的超高评分，被观众称为"快乐源泉"。中文字幕版由粉丝字幕组精心制作，将韩国文化的笑点和梗完美翻译。</p>',
    subtitleStatus: '中文字幕连载中',
    updateSpeed: '播出后12小时内出字幕',
    episodeCount: '最新季全11集',
    genre: ['旅行', '搞笑', '真人秀'],
    cast: ['姜虎东', '李寿根', '殷志源', '圭贤', '宋旻浩', 'P.O'],
    platforms: [
      { name: 'Viki', url: '#', hasSubtitle: true, speed: '播出后12小时' },
      { name: 'friDay影音', url: '#', hasSubtitle: true, speed: '播出后24小时' },
    ],
    tags: ['国民综艺', '罗英锡', '爆笑', '旅行'],
    featured: true,
    trending: false,
    updateDate: '2023-12-10',
    faq: [
      { question: '《新西游记》需要从第一季开始看吗？', answer: '不需要！每季都是独立的旅行目的地和游戏内容，可以直接从最新一季开始看。当然从第一季开始追会更能体会成员之间的感情变化。' },
    ],
  },
  {
    id: 'variety-2',
    title: '月曜夜未央',
    category: 'variety',
    categoryLabel: '日韩综艺',
    image: 'https://readdy.ai/api/search-image?query=A%20quirky%20Japanese%20variety%20show%20poster%20featuring%20two%20comedians%20in%20casual%20setting%2C%20late%20night%20talk%20show%20vibe%2C%20warm%20studio%20lighting%2C%20Japanese%20TV%20aesthetic%2C%20relaxed%20and%20funny%20atmosphere%2C%20minimalist%20design&width=800&height=1100&seq=variety-getsuyou-02&orientation=portrait',
    rating: 9.5,
    year: 2024,
    country: '日本',
    description: '日本深夜综艺常青树，松子和村上信五主持，以独特视角报道日本各地的"小问题"，笑料百出。',
    longDescription: '<p>《月曜夜未央》（月曜から夜ふかし）是日本电视台的王牌深夜综艺节目，由松子DELUXE和村上信五（SUPER EIGHT）主持。节目以"调查日本各地的小问题"为主题，采访全国各地的有趣人物和奇特现象，风格轻松幽默、不按套路出牌。</p><p>节目自2012年开播以来长盛不衰，松子和村上的绝妙搭档默契十足。中文字幕版由字幕组精心翻译，将日语中独特的幽默感和地域梗准确传达给中文观众。</p>',
    subtitleStatus: '中文字幕连载中',
    updateSpeed: '播出后24小时内出字幕',
    episodeCount: '每周一更新',
    genre: ['脱口秀', '纪实', '搞笑'],
    cast: ['松子DELUXE', '村上信五'],
    platforms: [
      { name: 'Bilibili', url: '#', hasSubtitle: true, speed: '播出后24小时' },
    ],
    tags: ['日本综艺', '松子', '深夜档', '搞笑'],
    featured: false,
    trending: false,
    updateDate: '2024-08-10',
    faq: [],
  },
  {
    id: 'jdrama-4',
    title: 'Last Man-全盲搜查官-',
    category: 'jdrama',
    categoryLabel: '日剧',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20detective%20drama%20poster%20featuring%20two%20men%20in%20suits%2C%20one%20wearing%20sunglasses%2C%20police%20themed%2C%20modern%20Tokyo%20cityscape%20background%2C%20dramatic%20lighting%2C%20professional%20investigation%20theme%2C%20warm%20amber%20colored%20gradient&width=800&height=1100&seq=jdrama-lastman-04&orientation=portrait',
    rating: 8.6,
    year: 2023,
    country: '日本',
    description: '福山雅治与大泉洋双主演的刑事剧，失明的FBI搜查官与日本警察搭档破案，剧情紧凑。',
    longDescription: '<p>《Last Man-全盲搜查官-》是TBS 2023年春季日剧，由福山雅治和大泉洋双主演。故事讲述因事故失明但仍保有FBI特别搜查官身份的皆实广见（福山雅治 饰），与日本警察厅的护道心太朗（大泉洋 饰）组成搭档，利用皆实超凡的听觉、嗅觉和推理能力解决各种疑难案件。</p><p>福山雅治继《神探伽利略》后再次出演推理题材，饰演的盲人搜查官既帅气又有温度。剧中对"无障碍"主题的探讨也获得了积极评价。</p>',
    subtitleStatus: '中文字幕已完结',
    updateSpeed: '播出后24小时内出字幕',
    episodeCount: '全10集',
    genre: ['刑侦', '推理', '剧情'],
    cast: ['福山雅治', '大泉洋', '永濑廉', '今田美樱'],
    platforms: [
      { name: 'KKTV', url: '#', hasSubtitle: true, speed: '播出后12小时' },
      { name: 'Netflix', url: '#', hasSubtitle: true, speed: '播出后24小时' },
    ],
    tags: ['刑侦剧', '福山雅治', '大泉洋', '推理'],
    featured: false,
    trending: false,
    updateDate: '2023-07-01',
    faq: [],
  },
  {
    id: 'jdrama-5',
    title: '下克上球儿',
    category: 'jdrama',
    categoryLabel: '日剧',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20sports%20drama%20poster%20featuring%20high%20school%20baseball%20players%20on%20field%2C%20inspiring%20and%20passionate%20atmosphere%2C%20golden%20sunset%20lighting%2C%20summer%20high%20school%20baseball%20theme%2C%20youthful%20energy%2C%20warm%20nostalgic%20colors&width=800&height=1100&seq=jdrama-baseball-05&orientation=portrait',
    rating: 9.1,
    year: 2023,
    country: '日本',
    description: '铃木亮平主演的热血棒球题材日剧，真实故事改编，讲述弱小高中棒球部逆袭甲子园的励志故事。',
    longDescription: '<p>《下克上球儿》（下剋上球児）是TBS 2023年秋季日剧，由铃木亮平主演，改编自日本真实高中棒球故事。故事讲述前高中棒球选手南云修司（铃木亮平 饰）成为三重县立白山高中的社会科教师后，带领一支只有一名正式队员的弱小棒球部，一步步逆袭冲向甲子园的热血故事。</p><p>本剧真实还原了日本高中棒球的残酷与感动，铃木亮平为了角色花了大量时间训练棒球，剧中的比赛场面真实震撼。播出后获得广泛好评，被誉为近年最好的棒球题材日剧。</p>',
    subtitleStatus: '中文字幕已完结',
    updateSpeed: '播出后24小时内出字幕',
    episodeCount: '全10集',
    genre: ['体育', '励志', '青春'],
    cast: ['铃木亮平', '黑木华', '井川遥', '生濑胜久'],
    platforms: [
      { name: 'Netflix', url: '#', hasSubtitle: true, speed: '全集上线' },
      { name: 'KKTV', url: '#', hasSubtitle: true, speed: '播出后12小时' },
    ],
    tags: ['热血', '棒球', '真实改编', '铃木亮平', '励志'],
    featured: false,
    trending: false,
    updateDate: '2023-12-20',
    faq: [],
  },
  {
    id: 'kdrama-4',
    title: 'Moving 异能',
    category: 'kdrama',
    categoryLabel: '韩剧',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20superhero%20drama%20poster%20with%20characters%20floating%20in%20air%2C%20action%20packed%20atmosphere%2C%20cinematic%20scale%2C%20dramatic%20sky%20background%2C%20warm%20cinematic%20lighting%2C%20Korean%20action%20drama%20aesthetic&width=800&height=1100&seq=kdrama-moving-04&orientation=portrait',
    rating: 9.1,
    year: 2023,
    country: '韩国',
    description: 'Disney+超级英雄题材韩剧，讲述隐藏超能力的高中生与父母的过去秘密，特效炸裂、情感动人。',
    longDescription: '<p>《Moving 异能》（무빙）是Disney+原创韩剧，改编自姜草的同名网络漫画，由柳承龙、韩孝周、赵寅成等实力派演员主演。故事设定在一个存在超能力者的世界，讲述隐藏自己超能力的高中生和她们同样拥有秘密过去的父母们，面对跨越世代的巨大危险的故事。</p><p>本剧以超过500亿韩元（约2.7亿人民币）的制作成本成为韩剧史上最贵的作品。剧中特效场面堪比好莱坞大片，同时对亲情、友情的刻画也感人至深。播出后成为Disney+全球观看量最高的韩剧。</p>',
    subtitleStatus: '中文字幕已完结',
    updateSpeed: 'Disney+同步上线中文字幕',
    episodeCount: '全20集',
    genre: ['动作', '科幻', '剧情'],
    cast: ['柳承龙', '韩孝周', '赵寅成', '车太铉', '金成均'],
    platforms: [
      { name: 'Disney+', url: '#', hasSubtitle: true, speed: '同步上线' },
    ],
    tags: ['超级英雄', '高成本制作', 'Disney+原创', '韩孝周'],
    featured: false,
    trending: true,
    updateDate: '2023-09-20',
    faq: [],
  },
  {
    id: 'movie-3',
    title: '怪物',
    category: 'movie',
    categoryLabel: '日韩电影',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20art%20film%20poster%20featuring%20a%20child%20in%20school%20uniform%20looking%20back%2C%20mysterious%20and%20emotional%20atmosphere%2C%20Kore-eda%20style%20human%20drama%2C%20soft%20natural%20lighting%2C%20minimalist%20Japanese%20cinema%20aesthetic%2C%20warm%20subdued%20colors&width=800&height=1100&seq=movie-monster-03&orientation=portrait',
    rating: 8.8,
    year: 2023,
    country: '日本',
    description: '是枝裕和导演、坂元裕二编剧的戛纳获奖作品，从三个视角讲述学校中一个"霸凌"事件背后的真相。',
    longDescription: '<p>《怪物》是2023年日本电影，由是枝裕和导演、坂元裕二编剧，安藤樱、永山瑛太主演。本片获得第76届戛纳电影节最佳编剧奖。故事从三个不同视角（母亲、老师、孩子）讲述小学中发生的一起"体罚事件"，随着视角切换，观众对真相的认知不断被颠覆，最终揭示出一个令人心碎的真相。</p><p>是枝裕和与坂元裕二两位日本电影界的顶尖创作者首次合作，加上坂本龙一的配乐（这也是坂本龙一生前最后一部电影配乐作品），使得本片成为2023年最受瞩目的日本电影之一。</p>',
    subtitleStatus: '中文字幕已上线',
    updateSpeed: '蓝光发售后24小时内出字幕',
    episodeCount: '片长127分钟',
    genre: ['剧情', '悬疑', '社会'],
    cast: ['安藤樱', '永山瑛太', '黑川想矢', '柊木阳太'],
    platforms: [
      { name: 'Netflix', url: '#', hasSubtitle: true, speed: '已上线' },
    ],
    tags: ['是枝裕和', '戛纳获奖', '坂元裕二', '坂本龙一'],
    featured: false,
    trending: false,
    updateDate: '2024-02-20',
    faq: [],
  },
  {
    id: 'variety-3',
    title: '街头美食斗士',
    category: 'variety',
    categoryLabel: '日韩综艺',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20food%20variety%20show%20poster%20featuring%20a%20man%20eating%20street%20food%20in%20bustling%20Asian%20market%2C%20mouthwatering%20food%20closeups%2C%20warm%20vibrant%20colors%2C%20travel%20and%20food%20theme%2C%20energetic%20street%20atmosphere%2C%20appetizing%20visuals&width=800&height=1100&seq=variety-streetfood-03&orientation=portrait',
    rating: 9.4,
    year: 2023,
    country: '韩国',
    description: '白种元老师的美食探店综艺，走遍世界各地寻找最地道的街头美食，吃饭场面让人垂涎欲滴。',
    longDescription: '<p>《街头美食斗士》（스트리트 푸드 파이터）是tvN推出的美食综艺节目，由韩国著名餐饮企业家兼美食家白种元主持。节目中白种元走遍世界各地（包括中国、日本、东南亚、欧美等），亲自探访当地最具代表性的街头美食，用专业又接地气的方式讲解食物背后的文化和故事。</p><p>白种元在节目中展现出的对食物的真诚热爱和渊博知识，加上他那让人忍不住咽口水的吃播画面，使这档节目成为"下饭综艺"的标杆之作。中文字幕版让中国观众也能感受到世界美食的魅力。</p>',
    subtitleStatus: '中文字幕已完结',
    updateSpeed: '播出后12小时内出字幕',
    episodeCount: '最新季全8集',
    genre: ['美食', '旅行', '真人秀'],
    cast: ['白种元'],
    platforms: [
      { name: 'Bilibili', url: '#', hasSubtitle: true, speed: '播出后12小时' },
      { name: 'Viki', url: '#', hasSubtitle: true, speed: '播出后24小时' },
    ],
    tags: ['美食综艺', '白种元', '街头美食', '下饭综艺'],
    featured: false,
    trending: false,
    updateDate: '2023-11-30',
    faq: [],
  },
  {
    id: 'movie-4',
    title: '首尔之春',
    category: 'movie',
    categoryLabel: '日韩电影',
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20historical%20political%20drama%20movie%20poster%20featuring%20military%20officers%20in%201970s%20uniform%2C%20tense%20political%20atmosphere%2C%20dark%20dramatic%20lighting%2C%20Korean%20modern%20history%20theme%2C%20cinematic%20intensity%2C%20muted%20military%20green%20tones&width=800&height=1100&seq=movie-seoulspring-04&orientation=portrait',
    rating: 9.2,
    year: 2023,
    country: '韩国',
    description: '黄政民、郑雨盛主演的韩国历史政治惊悚片，讲述1979年双十二政变的关键9小时。',
    longDescription: '<p>《首尔之春》（서울의 봄）是2023年韩国历史政治惊悚电影，由金成洙导演，黄政民、郑雨盛主演。影片以1979年12月12日韩国发生的军事政变为背景，讲述全斗光（黄政民 饰）发动军事叛乱夺取政权，而首都警备司令官李泰信（郑雨盛 饰）奋力抵抗的故事。</p><p>本片在韩国上映后引发巨大社会反响，观影人次突破1300万，成为2023年韩国最卖座的电影。黄政民和郑雨盛的演技对决极具张力，影片不仅是一部紧张刺激的政治惊悚片，更引发了对韩国现代史的深刻反思。</p>',
    subtitleStatus: '中文字幕已上线',
    updateSpeed: '蓝光发售后24小时内出字幕',
    episodeCount: '片长141分钟',
    genre: ['历史', '政治', '惊悚'],
    cast: ['黄政民', '郑雨盛', '李星民', '朴海俊'],
    platforms: [
      { name: 'Amazon Prime', url: '#', hasSubtitle: true, speed: '已上线' },
    ],
    tags: ['韩国票房冠军', '历史事件', '黄政民', '郑雨盛', '政治惊悚'],
    featured: false,
    trending: true,
    updateDate: '2024-04-10',
    faq: [],
  },
];

export const platformComparison = [
  {
    name: 'Netflix',
    logo: 'ri-netflix-fill',
    subtitleSpeed: '同步上线',
    subtitleQuality: '★★★★★',
    subtitleLanguages: '中文简繁、英、日、韩等',
    contentVolume: '日韩内容200+部',
    price: 'NT$270/月起',
    highlight: true,
    note: '原创剧集字幕质量最高，部分作品同步上线中文字幕',
  },
  {
    name: 'KKTV',
    logo: 'ri-tv-line',
    subtitleSpeed: '播出后6-12小时',
    subtitleQuality: '★★★★★',
    subtitleLanguages: '中文繁体为主',
    contentVolume: '日剧300+部',
    price: 'NT$149/月起',
    highlight: true,
    note: '日剧最强平台，更新速度极快，翻译品质优秀',
  },
  {
    name: 'friDay影音',
    logo: 'ri-movie-line',
    subtitleSpeed: '播出后12-24小时',
    subtitleQuality: '★★★★☆',
    subtitleLanguages: '中文繁体为主',
    contentVolume: '日韩内容250+部',
    price: 'NT$199/月起',
    highlight: false,
    note: '韩剧更新及时，日剧也有一定覆盖',
  },
  {
    name: 'Disney+',
    logo: 'ri-film-line',
    subtitleSpeed: '同步上线',
    subtitleQuality: '★★★★★',
    subtitleLanguages: '中文简繁、英、日、韩等',
    contentVolume: '韩剧30+部',
    price: 'NT$270/月起',
    highlight: false,
    note: '原创韩剧品质极高，如《Moving异能》等',
  },
  {
    name: 'Viki',
    logo: 'ri-global-line',
    subtitleSpeed: '播出后8-24小时',
    subtitleQuality: '★★★★☆',
    subtitleLanguages: '中文、英、西、法等20+语言',
    contentVolume: '日韩内容500+部',
    price: 'US$4.99/月起',
    highlight: false,
    note: '覆盖范围最广，社区字幕翻译多语言',
  },
  {
    name: 'Bilibili',
    logo: 'ri-bilibili-line',
    subtitleSpeed: '播出后12-24小时',
    subtitleQuality: '★★★★☆',
    subtitleLanguages: '中文简体为主',
    contentVolume: '日韩综艺100+部',
    price: '免费（部分会员）',
    highlight: false,
    note: '日韩综艺资源丰富，社区氛围好，弹幕有趣',
  },
];

export const testimonials = [
  {
    name: '小樱',
    role: '日剧爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20clean%20studio%20lighting%2C%20professional%20headshot%20style%2C%20neutral%20cream%20background%2C%20friendly%20expression&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '追日剧三年了，这个平台帮我找到了超多优质中文字幕资源，更新速度对比功能太实用了！再也不用到处找字幕了。',
    rating: 5,
  },
  {
    name: '韩剧控小王',
    role: '韩剧重度用户',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20man%20portrait%20with%20friendly%20expression%2C%20clean%20studio%20lighting%2C%20professional%20headshot%20style%2C%20neutral%20cream%20background&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '作为一个追剧狂魔，这个导航站让我的追剧效率提升了好几倍。分类清晰，推荐精准，每周都会来看看有什么新剧更新。',
    rating: 5,
  },
  {
    name: '电影迷老张',
    role: '日韩电影爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20middle%20aged%20Asian%20man%20portrait%20with%20warm%20smile%2C%20clean%20studio%20lighting%2C%20professional%20headshot%20style%2C%20neutral%20cream%20background&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '日韩电影的中文字幕资源一直比较难找，这个平台罗列得非常全面，连一些小众独立电影的字幕信息都有收录，太赞了！',
    rating: 5,
  },
];

export const faqs: { question: string; answer: string }[] = [
  {
    question: '中文字幕日韩影视导航是什么？',
    answer: '我们是一个专注于中文字幕日韩影视资源的导航平台。涵盖日剧、韩剧、日韩电影、日韩综艺四大品类，为用户提供内容推荐、更新速度对比和观看平台指引，帮助中文用户轻松获取高质量的日韩影视中文字幕资源。',
  },
  {
    question: '如何找到最新的中文字幕日韩剧资源？',
    answer: '您可以在首页"更新排行"区域查看最新的日韩剧中文字幕更新动态，也可以在分类页面按"最新更新"排序浏览。我们标注了每部作品的字幕更新速度和推荐观看平台，帮助您快速找到最优质的资源。',
  },
  {
    question: '哪些平台提供日韩影视中文字幕？',
    answer: '目前Netflix、KKTV、friDay影音、Disney+、Viki、Bilibili等平台都提供日韩影视的中文字幕版本。我们在"平台对比"区域详细对比了各平台的字幕质量、更新速度和内容覆盖，方便您选择最适合的观看平台。',
  },
  {
    question: '中文字幕的翻译质量如何？',
    answer: '我们收录的作品中文字幕均来自专业字幕组或官方平台翻译，质量有保证。在内容详情页中，我们会标注字幕的翻译质量和来源，让用户对字幕质量一目了然。针对不同平台，我们也会进行字幕质量的对比评价。',
  },
  {
    question: '网站推荐的日韩剧都是免费的么？',
    answer: '我们是一个资源导航平台，本身不提供视频播放服务，而是帮助用户找到提供中文字幕的正规观看平台。部分平台需要付费订阅（如Netflix、KKTV等），也有部分免费平台（如Bilibili的部分内容）。我们会在详情页标注各平台的付费情况。',
  },
  {
    question: '中文字幕日韩综艺有哪些推荐？',
    answer: '我们推荐多档热门日韩综艺，包括韩国国民综艺《新西游记》、日本深夜王牌《月曜夜未央》、美食探店《街头美食斗士》等。所有推荐综艺均有中文字幕版本，在分类页的"日韩综艺"标签下可以浏览完整列表。',
  },
];

export const siteInfo = {
  name: '中文字幕日韩影视导航',
  tagline: '告别语言障碍，轻松追日韩好剧',
  description: '专注中文字幕日韩影视资源导航，涵盖日韩剧、电影、综艺全品类，提供高清中文字幕日韩内容推荐、更新速度对比及观看平台指引，帮助中文用户轻松追剧。',
  founded: '2023年',
  email: 'contact@zhongwenzimurihan.com',
  wechat: '日韩影视导航',
  address: '北京市朝阳区',
};